"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Apple = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Apple = function Apple(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.981 0C11.041 2.127 9.52 3.603 8 3.51 7.75 1.814 9.52 0 10.981 0zM1.44 8.65c0 2.475 1.97 7.336 4.35 7.35h.017c.591 0 1.113-.195 1.575-.367l.004-.001c.338-.127.658-.247.91-.247.499 0 .8.128 1.15.277.346.147.738.314 1.292.314 2.265 0 3.825-4.198 3.825-4.393 0-.299-.227-.436-.447-.568l-.002-.001c-.5-.301-1.54-.927-1.54-2.552 0-1.373.919-2.066 1.422-2.446l.353-.266-.245-.368c-1.046-1.57-2.785-1.696-3.358-1.696h-.005c-.768 0-1.428.263-1.958.474l-.01.004c-.246.097-.521.206-.64.206-.199 0-.558-.132-.905-.26-.496-.183-1.058-.39-1.585-.39-1.17 0-4.203.886-4.203 4.93z",
    fill: "currentColor"
  }));
};

exports.Apple = Apple;
var _default = Apple;
exports.default = _default;